// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { ApiService } from "./apiEndpoints";

// Values mapped from public/google-services.json. The app ID below is for the
// info.utkarshabhyasika Firebase client.
const firebaseConfig = {
  apiKey: "AIzaSyCfPV3H_jKdJpULGe7GVrw7sDu2VZ7gWK4",
  authDomain: "utkarsh-abhyasika.firebaseapp.com",
  projectId: "utkarsh-abhyasika",
  storageBucket: "utkarsh-abhyasika.firebasestorage.app",
  messagingSenderId: "636313971745",
  appId: "1:636313971745:android:f04ebf9b50ab3177070760",
  vapidKey: "BF8qR410kKKaV2_3IcKujONEw-N290c4sXnPjmqAFk5RBfynVfxuZGpWFXaEJnlsvOzISpEDshv_zvF_pMIE5ns"
};

const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || firebaseConfig.vapidKey;

const app = initializeApp(firebaseConfig);

// FCM is only available in supported browser contexts (for example, an iOS
// Home Screen web app). Calling getMessaging() in a regular iOS Safari tab
// throws before the UI can render, so initialize it only after this check.
export let messaging = null;
const messagingReady = (async () => {
  try {
    if (typeof window === "undefined" || !(await isSupported())) {
      console.warn("FCM messaging is not supported in this browser context.");
      return null;
    }

    messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    console.warn("FCM messaging could not be initialized.", error);
    return null;
  }
})();

// Helper to request permission and fetch the token (Replaces onNewToken)
export const requestFcmToken = async (studentId) => {
  try {
    const messagingInstance = await messagingReady;
    if (!messagingInstance) {
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      if (!vapidKey) {
        console.warn("FCM is not configured: REACT_APP_FIREBASE_VAPID_KEY is missing.");
        return null;
      }

      // The VAPID key comes from Firebase Console → Project Settings → Cloud Messaging.
      // Reuse the registered PWA worker. Without this, Firebase tries to load
      // /firebase-messaging-sw.js, which is not this application's worker.
      const serviceWorkerRegistration = await navigator.serviceWorker.ready;
      const currentToken = await getToken(messagingInstance, { vapidKey, serviceWorkerRegistration });

      if (currentToken) {
        console.log("📡 Web FCM Token:", currentToken);
        // Save token to backend (Equivalent to Session.sendTokenToBackend)
        await ApiService.saveFcmToken({ studentId, token: currentToken });
        return currentToken;
      }
    }
  } catch (error) {
    console.error("FCM Token Error:", error);
  }
  return null;
};
